// Vendor Libs
import {cloneDeep, get, omit, set} from 'lodash';

// Config
const initialState = {
    lastRoute: null,
    lastUpdate: 0,
    layouts: {},
};
let lastLayout;

const actions = {
    LAYOUT_REGISTER: (state, {dashboardName}) => {
        lastLayout = dashboardName;
        return state;
    },

    LAYOUT_RESET: (state, {dashboardName}) => {
        const newState = cloneDeep(state);
        const name = dashboardName || lastLayout;

        return name ? set(newState, 'layouts', omit(newState.layouts, name)) : newState;
    },

    LAYOUT_UNREGISTER: (state, {dashboardName}) => {
        const newState = cloneDeep(state);

        return set(newState, 'layouts', omit(newState.layouts, dashboardName || state.lastLayout));
    },

    LAYOUT_UPDATE: (state, {dashboardName, layout}) => set(cloneDeep(state), ['layouts', dashboardName], layout),

    PREFERENCES_LOAD: (state, {stores}) => {
        const layouts = get(stores, 'layout.layouts');

        return layouts ? set(cloneDeep(state), 'layouts', layouts) : state;
    },

    PREFERENCES_RESET: state => cloneDeep(initialState),
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
